<div class="content-wrapper">
  <div class="container">

    <div *ngIf="SA">

      <!-- Create Tenant -->
      <div class="row mt-3">
        <div class="col-12 d-flex justify-content-end">

          <button
            class="btn btn-primary book-now-btn"
            (click)="CreateNewTenant()">

            Create New Tenant

          </button>

        </div>
      </div>

      <!-- Grid -->

      <div class="row mt-3">

        <div class="col-12">

          <div class="tenantsGrid">

            <ag-grid-angular
              style="width:100%;height:1000px;"
              class="ag-theme-alpine"
              [rowData]="rowData"
              [columnDefs]="columnDefs"
              (gridReady)="onGridReady($event)"
              (rowClicked)="onRowClicked($event)">

            </ag-grid-angular>

          </div>

        </div>

      </div>

    </div>

  </div>


  <!-- ====================================================== -->
  <!-- Tenant Configuration Popup -->
  <!-- ====================================================== -->

  <ng-template #confirmCancel let-modal>

    <div class="modal-header">

      <h5 class="modal-title">

        Tenant Configuration

      </h5>

      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('cancel')">

      </button>

    </div>


    <div class="modal-body">

      <!-- ====================================================== -->
      <!-- Tenant Display Sequence -->
      <!-- ====================================================== -->

      <div class="form-group">

        <label>

          Display Sequence

        </label>

        <input
          type="number"
          class="form-control"
          min="1"
          [(ngModel)]="sequence">

      </div>


      <!-- ====================================================== -->
      <!-- Services Offered -->
      <!-- ====================================================== -->

      <div class="form-group mt-3">

        <label>

          Services Offered

        </label>

        <mat-form-field appearance="outline" style="width:100%;">

          <mat-label>Select Services</mat-label>

          <mat-select
            multiple
            [(ngModel)]="selectedServices">

            <mat-option
              *ngFor="let service of availableServices"
              [value]="service">

              {{service}}

            </mat-option>

          </mat-select>

        </mat-form-field>

      </div>


      <hr>

      <h5>

        Convenience Fee Configuration

      </h5>


      <!-- Fee Configuration Table -->

      <table class="fee-table w-100 mb-0">
        <thead>
          <tr>
            <th class="col-product-type"></th>
            <th class="col-pg-fee text-center">💳 Platform Fee (PG)</th>
            <th class="col-cash-fee text-center">💵 Platform Fee (Cash)</th>
            <th class="col-end-user text-center">👤 End User (PG)</th>
          </tr>
        </thead>
        <tbody>
          <tr class="fee-row">
            <td class="col-product-type">
              <span class="product-label">
                <i class="material-icons product-icon">event_available</i>
                Single Session
              </span>
            </td>

            <td class="col-pg-fee">
              <div class="fee-input-group">
                <input type="number" class="form-control form-control-sm fee-input"
                       [(ngModel)]="singlePgFee" placeholder="0" min="0">
                <div class="btn-group btn-group-sm type-toggle" role="group">
                  <button type="button" class="btn"
                    [class.btn-primary]="singlePgFeeType === 'percentage'"
                    [class.btn-outline-secondary]="singlePgFeeType !== 'percentage'"
                    (click)="singlePgFeeType = 'percentage'">%</button>
                  <button type="button" class="btn"
                    [class.btn-primary]="singlePgFeeType === 'absolute'"
                    [class.btn-outline-secondary]="singlePgFeeType !== 'absolute'"
                    (click)="singlePgFeeType = 'absolute'">₹</button>
                </div>
              </div>
            </td>

            <td class="col-cash-fee">
              <div class="fee-input-group">
                <input type="number" class="form-control form-control-sm fee-input"
                       [(ngModel)]="singleCashFee" placeholder="0" min="0">
                <div class="btn-group btn-group-sm type-toggle" role="group">
                  <button type="button" class="btn"
                    [class.btn-primary]="singleCashFeeType === 'percentage'"
                    [class.btn-outline-secondary]="singleCashFeeType !== 'percentage'"
                    (click)="singleCashFeeType = 'percentage'">%</button>
                  <button type="button" class="btn"
                    [class.btn-primary]="singleCashFeeType === 'absolute'"
                    [class.btn-outline-secondary]="singleCashFeeType !== 'absolute'"
                    (click)="singleCashFeeType = 'absolute'">₹</button>
                </div>
              </div>
            </td>

            <td class="col-end-user">
              <div class="fee-input-group">
                <input type="number" class="form-control form-control-sm fee-input"
                       [(ngModel)]="singleEndUserFee" placeholder="0" min="0">
                <div class="btn-group btn-group-sm type-toggle" role="group">
                  <button type="button" class="btn"
                    [class.btn-primary]="singleEndUserFeeType === 'percentage'"
                    [class.btn-outline-secondary]="singleEndUserFeeType !== 'percentage'"
                    (click)="singleEndUserFeeType = 'percentage'">%</button>
                  <button type="button" class="btn"
                    [class.btn-primary]="singleEndUserFeeType === 'absolute'"
                    [class.btn-outline-secondary]="singleEndUserFeeType !== 'absolute'"
                    (click)="singleEndUserFeeType = 'absolute'">₹</button>
                </div>
              </div>
            </td>
          </tr>

          <tr class="fee-row">
            <td class="col-product-type">
              <span class="product-label">
                <i class="material-icons product-icon">date_range</i>
                Multi Session / Flexi
              </span>
            </td>

            <td class="col-pg-fee">
              <div class="fee-input-group">
                <input type="number" class="form-control form-control-sm fee-input"
                       [(ngModel)]="multiPgFee" placeholder="0" min="0">
                <div class="btn-group btn-group-sm type-toggle" role="group">
                  <button type="button" class="btn"
                    [class.btn-primary]="multiPgFeeType === 'percentage'"
                    [class.btn-outline-secondary]="multiPgFeeType !== 'percentage'"
                    (click)="multiPgFeeType = 'percentage'">%</button>
                  <button type="button" class="btn"
                    [class.btn-primary]="multiPgFeeType === 'absolute'"
                    [class.btn-outline-secondary]="multiPgFeeType !== 'absolute'"
                    (click)="multiPgFeeType = 'absolute'">₹</button>
                </div>
              </div>
            </td>

            <td class="col-cash-fee">
              <div class="fee-input-group">
                <input type="number" class="form-control form-control-sm fee-input"
                       [(ngModel)]="multiCashFee" placeholder="0" min="0">
                <div class="btn-group btn-group-sm type-toggle" role="group">
                  <button type="button" class="btn"
                    [class.btn-primary]="multiCashFeeType === 'percentage'"
                    [class.btn-outline-secondary]="multiCashFeeType !== 'percentage'"
                    (click)="multiCashFeeType = 'percentage'">%</button>
                  <button type="button" class="btn"
                    [class.btn-primary]="multiCashFeeType === 'absolute'"
                    [class.btn-outline-secondary]="multiCashFeeType !== 'absolute'"
                    (click)="multiCashFeeType = 'absolute'">₹</button>
                </div>
              </div>
            </td>

            <td class="col-end-user">
              <div class="fee-input-group">
                <input type="number" class="form-control form-control-sm fee-input"
                       [(ngModel)]="multiEndUserFee" placeholder="0" min="0">
                <div class="btn-group btn-group-sm type-toggle" role="group">
                  <button type="button" class="btn"
                    [class.btn-primary]="multiEndUserFeeType === 'percentage'"
                    [class.btn-outline-secondary]="multiEndUserFeeType !== 'percentage'"
                    (click)="multiEndUserFeeType = 'percentage'">%</button>
                  <button type="button" class="btn"
                    [class.btn-primary]="multiEndUserFeeType === 'absolute'"
                    [class.btn-outline-secondary]="multiEndUserFeeType !== 'absolute'"
                    (click)="multiEndUserFeeType = 'absolute'">₹</button>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

    </div>


    <!-- ====================================================== -->
    <!-- Footer -->
    <!-- ====================================================== -->

    <div class="modal-footer">

      <!--<button
        class="btn btn-info me-auto"
        (click)="downloadConfiguration()">

        Download tenant-config.json

      </button>-->

      <button
        class="btn btn-success"
        (click)="modal.close('yes')">

        Save

      </button>

      <button
        class="btn btn-secondary"
        (click)="modal.dismiss('no')">

        Cancel

      </button>

    </div>

  </ng-template>

</div>

<router-outlet></router-outlet>
